import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { SetupBanner } from './SetupBanner';
import { MobilePageBar } from './MobilePageBar';

export function PublicLayout() {
  return (
    <div className="flex min-h-screen flex-col">
      <SetupBanner />
      <Header />
      <MobilePageBar />
      <main className="flex-1 pb-12">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
